export const formatTitle = (...elements: (string | number)[]): string => {
  return elements.join(", ");
};
